import { api } from "@/modules/api";

export const getElectricAuthHeaders = async (): Promise<{ Authorization: string }> => {
  const authToken = api.getAuthToken();

  return {
    Authorization: authToken ? `OAuthAccessToken ${authToken}` : "",
  };
};
